// @file Surface post action store
// TODO: [to-be-migrated][post_action]
import { getVuexStore } from '@@/bits/pinia'
import type { Cid } from '@@/types'
import type { BeethovenDisplayAttributes } from '@padlet/beethoven-client'
import { defineStore } from 'pinia'
import { computed } from 'vue'
import type { RootState as SurfaceRootState } from 'vuexstore/surface/types'

export const useSurfacePostActionStore = defineStore('postAction', () => {
  const vuexStore = getVuexStore<SurfaceRootState>()

  const currentlyPlayingPostCid = computed(() => vuexStore?.state.postAction.currentlyPlayingPostCid)

  function setCurrentlyPlayingPostCid(cid: Cid | null): void {
    void vuexStore?.dispatch('postAction/setCurrentlyPlayingPost', { cid })
  }

  function unsetCurrentlyPlayingPost(): void {
    void vuexStore?.dispatch('postAction/unsetCurrentlyPlayingPost')
  }

  function zoomPost(payload: { zoomedPostCid: Cid; zoomedLink: BeethovenDisplayAttributes }): void {
    void vuexStore?.dispatch('postAction/zoomPost', payload)
  }

  return {
    // getters
    currentlyPlayingPostCid,

    // actions
    setCurrentlyPlayingPostCid,
    unsetCurrentlyPlayingPost,
    zoomPost,
  }
})
